import React, { useState, useEffect } from "react"
import axios from 'axios';
import { getCITarrifOne, getBanks, getEmailNotificationType, getEmailNotification, inActiveEmailNotifications, getEmailNotificationSubaccout, getCustomerInfo, UpdateBankDetails } from '../../services/userservice';
import { setLoading } from '../../redux/appSlice';
import { isRealObject, onlyStr, processInt, processStr, processStrForIBAN, processStrWithSpace, valdiatePage } from '../../global';
import { useDispatch, useSelector } from "react-redux";
import './customerinfo.css'
import { getAccountBranches } from "../../services/bookingservice";
import EmailNotificationsAdd from "./emailnotificationadd";
import EmailNotificationsUpdate from "./emailnotificationupdate";
import { useHistory } from "react-router-dom";

const CustomerInfo = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { loading, userInfo, accounts } = useSelector(state => state.appData)
    const d = {
        accountNo: '',
        branchCode: '',
        address: "",
        bankBranchCode: 0,
        bankName: "",
        beneficiaryBankAccNo: "",
        beneficiaryName: "",
        beneficiaryRelation: "",
        branchCityName: "",
        businessName: "",
        contactPerson: "",
        creditTermsDays: null,
        designation: "",
        email: "",
        fafType: true,
        faxNo: "",
        fromWeight: 0,
        invoiceDecisions: false,
        invoiceschedule: true,
        isCOD: true,
        isMinBilling: false,
        ntnNumber: "",
        phoneNo: "",
        pocEmail: "",
        rates: 0,
        regDate: "",
        salesExecutive: "",
        serviceID: null,
        toWeight: 0,
        industry: '',
        sales_PH_no: '',
        pocPhoneNo: '',
        serviceType: '',

        fuelFactor: "",
        recoveryType: null,
        salesdecisions: "",
        billingInstruction: "",
        annualRateRevision: "",
        eInvoicing: "",
        printinvoice: 0,
        recoveryMode: null,
        taxExceptions: "",
        fuelFactorValue: 0,
        recoveryMode: null,
        minBillingAmount: 0,
        salesPerson: "",
        locations: [],
        subAccounts: []
    }

    const bankD = {
        bankBranchCode: "",
        bankName: "",
        beneficiaryBankAccNo: "",
        beneficiaryName: "",
        beneficiaryRelation: "",
        branchCityName: ""
    }

    const END = {
        id: 0,
        ToEmail: "",
        CcEmail: "",
        emailType: [],
    }


    const emailNotificationD = {
        subAccountId: 0,
        locationId: 0,
        notifications: []
    }

    const [branches, setBranches] = useState([]);
    const [banks, setBanks] = useState([]);
    const [data, setData] = useState(d);
    const [tariffOne, setTariffOne] = useState([]);
    const [bankdata, setBankData] = useState(bankD);
    const [editType, setEditType] = useState(false);

    const [emailNotificationType, setEmailNotificationType] = useState([]);
    const [emailData, setEmailData] = useState(END);
    const [emailNotifications, setEmailNotifications] = useState([]);
    const [viewType, setViewType] = useState('list');
    const [emailNotificationPayload, setEmailNotificationPayload] = useState(emailNotificationD);
    const [subAccWithLoc, setSubAccWithLoc] = useState([]);


    const updateData = (key, val) => { setData(prev => { return { ...prev, [key]: val } }); }
    const updateEmailData = (key, val) => { setEmailData(prev => { return { ...prev, [key]: val } }); }

    useEffect(async () => {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        if (valdiatePage('/customerinfo')) {
            dispatch(setLoading({ data: true }));
            updateData('accountNo', accounts[0])
            getAccountBranch(accounts[0])
            getBanks().then(x => {
                if (x.banks && x.banks.length > 0) {
                    setBanks(x.banks);
                }
            })
            const rs = await getEmailNotificationType();
            dispatch(setLoading({ data: false }));

            if (rs && rs.length > 0) {
                setEmailNotificationType(rs);
            } else {
                setEmailNotificationType([])

            }
        } else {
            history.push('/login');
        }
        return () => {
            source.cancel('Operation canceled by the user.');
        }
    }, [])


    useEffect(async () => {
        if (viewType === 'list') {
            getEmailNotificationCall()
        }
    }, [data.accountNo, viewType])

    const getEmailNotificationCall = async () => {
        if (!data.accountNo || data.accountNo.trim() == '') {
            return;
        }
        const ers = await getEmailNotification(data.accountNo);
        if (ers && ers.length > 0)
            setEmailNotifications(ers);
        else {
            setEmailNotifications([])
        }
    }

    const getAccountBranch = async (accountNo) => {
        updateData('accountNo', accountNo)
        if (!accountNo) {
            alert('Select Account No');
            return;
        }
        dispatch(setLoading({ data: true }));
        if (accountNo)
            await getAccountBranches(accountNo).then(rs => {
                if (rs && rs.ok) {
                    setData({ ...d, accountNo: accountNo })
                    setBranches(rs.data);
                    dispatch(setLoading({ data: false }));
                }
                else {
                    setBranches([]);
                }
            })
    }

    const getCustomerInformation = async (branchCode) => {
        updateData('branchCode', branchCode)

        if (!data.accountNo) {
            alert('Select Account No');
            return;
        }

        if (!branchCode) {
            alert('Select Branch');
            return;
        }
        dispatch(setLoading({ data: true }));
        getCITarrif("4k44")
        const rs = await getCustomerInfo(branchCode, data.accountNo);
        dispatch(setLoading({ data: false }));

        if (rs && rs.ok && rs.data.length > 0)
            setData(prev => { return { ...prev, ...rs.data[0] } });
        else {
            setData({ ...d, branchCode: branchCode, accountNo: data.accountNo })
        }
    }

    const getCITarrif = async (accountNo) => {

        if (!accountNo) {
            alert('Select Account No');
            return;
        }

        const rsOne = await getCITarrifOne(accountNo);
        if (rsOne && rsOne.ok)
            setTariffOne(rsOne.data);
        else {
            setTariffOne([])
        }
    }

    const editBankDetail = async (val) => {

        if (!data.accountNo) {
            alert('Select Account No');
            return;
        }

        if (!data.branchCode) {
            alert('Select Branch');
            return;
        }

        if (val) {
            setEditType(val);
            setBankData({
                beneficiaryBankAccNo: data.beneficiaryBankAccNo,
                beneficiaryName: data.beneficiaryName,
                bankName: data.bankName,
                bankBranchCode: data.bankBranchCode,
                branchCityName: data.branchCityName,
                beneficiaryRelation: data.beneficiaryRelation
            })
        }

        if (!val) {
            const payload = {
                iban: data.beneficiaryBankAccNo,
                beneficiaryName: data.beneficiaryName,
                bankCode: String(data.bankBranchCode),
                beneficiaryRelation: data.beneficiaryRelation
            }

            if (!data.beneficiaryName || data.beneficiaryName.trim() == '') {
                alert('Enter Beneficiary Name');
                return;
            }

            if (!data.beneficiaryRelation || data.beneficiaryRelation.trim() == '') {
                alert('Enter Beneficiary Relation');
                return;
            }

            if (!data.beneficiaryBankAccNo || data.beneficiaryBankAccNo.trim() == '') {
                alert('Enter IBAN');
                return;
            }

            if (data.beneficiaryBankAccNo.length !== 24) {
                alert("Invalid IBAN")
                return;
            }

            if (!data.bankBranchCode || data.bankBranchCode == 0) {
                alert('Select Bank.');
                return;
            }

            if (!data.branchCityName || data.branchCityName.trim() == '') {
                alert('Enter branch name');
                return;
            }

            dispatch(setLoading({ data: true }));
            const rs = await UpdateBankDetails({ accountNo: data.accountNo, branchCode: data.branchCode }, payload)
            dispatch(setLoading({ data: false }));
            if (rs.sts === 0 && isRealObject(rs.data)) {
                alert(rs.msg)
                setEditType(false);
            } else {
                alert(rs.msg);
                setEditType(true);
            }
        }
    }

    const onEdit = async (x) => {
        if (!x.id || x.id !== "") {
            updateEmailData("id", x.id)
            updateEmailData("ToEmail", x.ToEmail)
            updateEmailData("CcEmail", x.CcEmail)
            updateEmailData("emailType", x.ReportType.split(",").filter(e => e !== "").map(e => Number(e)))
            setViewType('edit')

            dispatch(setLoading({ data: true }));
            const rs = await getEmailNotificationSubaccout(x.id);
            dispatch(setLoading({ data: false }));

            if (rs.ok && rs.data.length > 0) {
                setSubAccWithLoc(rs.data.map(e => ({
                    subAccount: {
                        id: e.subaccountId,
                    },
                    locations: e.locations.map(e => e.locationId)
                })))
                updateData('subAccounts', rs.data.map(e => e.subaccountId));
            }
        }
    }

    const onAdd = () => {
        if (emailNotifications.length <= 4) {
            setEmailData(END)
            setEmailNotificationPayload(prev => { return { ...prev, notifications: [] } })
            setViewType('add')
        } else {
            alert("You can add maximum 5 Email Notifications records.")
        }
    }

    const updateEmailNotificationPayload = (key, val) => {
        setEmailNotificationPayload({ ...emailNotificationPayload, [key]: val });
    }

    const removeEmail = async (x) => {

        if (window.confirm('Are you sure?')) {
            dispatch(setLoading({ data: true }));
            const rs = await inActiveEmailNotifications(x.id)
            dispatch(setLoading({ data: false }));
            if (rs.sts === 0) {
                alert("Email removed successfully")
                getEmailNotificationCall()
            } else {
                alert(rs.msg);
            }
        }
    }


    return userInfo && <section className="section">
        {viewType === 'list' ?
            <>
                <div className="section-header">
                    <h1>Customer Info</h1>
                </div>
                <div className="card" style={{ padding: 10 }}>
                    <div className="row section-border top-bottom-padding" >
                        <div className="col-lg-3 col-sm-12">
                            <label>Account</label>
                            <select className="form-select" value={data.accountNo} onChange={e => getAccountBranch(e.target.value)}>
                                <option value="">Select Account</option>
                                {
                                    accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                                }
                            </select>
                        </div>
                        <div className="col-lg-3 col-sm-12">
                            <label>Branches</label>
                            <select className="form-select" value={data.branchCode} onChange={e => getCustomerInformation(e.target.value)}>
                                <option value="">Select Branch</option>
                                {
                                    branches.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                                }
                            </select>
                        </div>
                    </div>
                    <fieldset className="customer-info-fieldset">
                        <legend className="customer-info-legend" data-bs-toggle="collapse" data-bs-target="#customerInfo" aria-expanded="false" aria-controls="customerInfo">Customer Information: </legend>
                        <div className="collapse show" id="customerInfo">
                            <div className="row mt-3">
                                <div className="col-lg-8 col-sm-12">
                                    <label>Business Name</label>
                                    <input type="text" className="form-control" value={data.businessName} disabled />
                                </div>
                                <div className="col-lg-4 col-sm-12">
                                    <label>Industry</label>
                                    <input type="text" className="form-control" value={data?.industry} disabled />
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-lg-4 col-sm-12">
                                    <label>Contact Person</label>
                                    <input type="text" className="form-control" value={data.contactPerson} disabled />
                                </div>
                                <div className="col-lg-4 col-sm-12">
                                    <label>Designation</label>
                                    <input type="text" className="form-control" value={data.designation} disabled />
                                </div>
                                <div className="col-lg-4 col-sm-12">
                                    <label>Phone Number</label>
                                    <input type="text" className="form-control" value={data.phoneNo} disabled />
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-lg-4 col-sm-12">
                                    <label>Fax Number</label>
                                    <input type="text" className="form-control" value={data.faxNo} disabled />
                                </div>
                                <div className="col-lg-4 col-sm-12">
                                    <label>Email ID</label>
                                    <input type="text" className="form-control" value={data.email} disabled />
                                </div>
                                <div className="col-lg-4 col-sm-12">
                                    <label>CNIC</label>
                                    <input type="text" className="form-control" value={data?.cnic} disabled />
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-lg-4 col-sm-12">
                                    <label>NTN Registered</label>
                                    <input type="text" className="form-control" value={!!data.ntnNumber ? "YES" : "NO"} disabled />
                                </div>
                                <div className="col-lg-4 col-sm-12">
                                    <label>NTN Number</label>
                                    <input type="text" className="form-control" value={data.ntnNumber} disabled />
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-lg-12 col-sm-12">
                                    <label>Customer Address</label>
                                    <textarea className="form-control" value={data.address} disabled></textarea>
                                </div>
                            </div>
                        </div>
                    </fieldset>


                    <fieldset className="customer-info-fieldset">
                        <legend className="customer-info-legend" data-bs-toggle="collapse" data-bs-target="#bankDetails" aria-expanded="false" aria-controls="bankDetails">Bank Details: </legend>
                        <div className="collapse show" id="bankDetails">
                            {/* <div>
                                <div className="col-lg col-sm-12" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                    {editType && <button type="button" className="btn btn-primary" style={{ marginRight: "10px" }} disabled={loading} onClick={() => setEditType(false)}>{"Cancel"}</button>} <button type="button" className="btn btn-primary" disabled={loading} onClick={() => editBankDetail(!editType)}>{!editType ? "Edit" : "Update"}</button>
                                </div>
                            </div> */}
                            <div className="row">
                                <div className="col-lg-4 col-sm-12">
                                    <label>Beneficiary Name</label>
                                    <input type="text" className="form-control" maxLength={50} value={data?.beneficiaryName} disabled={!editType} onInput={onlyStr} onChange={e => updateData('beneficiaryName', e.target.value)} />
                                </div>
                                <div className="col-lg-4 col-sm-12">
                                    <label>Beneficiary Relation</label>
                                    <input type="text" className="form-control" maxLength={50} value={data?.beneficiaryRelation} disabled={!editType} onInput={onlyStr} onChange={e => updateData('beneficiaryRelation', e.target.value)} />
                                </div>
                                <div className="col-lg-4 col-sm-12">
                                    <label>IBAN</label>
                                    <input type="text" className="form-control" minLength={24} maxLength={29} value={data?.beneficiaryBankAccNo} disabled={!editType} onInput={processStrForIBAN} onChange={e => updateData('beneficiaryBankAccNo', e.target.value)} />
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-lg-4 col-sm-12">
                                    <label>Bank Name</label>
                                    <select className="form-select" value={data?.bankBranchCode} disabled={!editType} onChange={e => updateData('bankBranchCode', e.target.value)}>
                                        <option value="">Select Account</option>
                                        {
                                            banks.map((x, index) => <option key={index} value={x.id}>{x.name}</option>)
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                    </fieldset>


                    {/* <fieldset className="customer-info-fieldset">
                        <legend className="customer-info-legend" data-bs-toggle="collapse" data-bs-target="#tariff" aria-expanded="false" aria-controls="tariff">Tariff: </legend>
                        <div className="collapse show" id="tariff">
                            <div className="row" style={{ padding: "12px" }}>

                                {
                                    tariffOne.length > 0 ? tariffOne.map((e, index) => (<div key={index} className="row col-lg-3 col-sm-12" style={{ marginRight: '1px', marginTop: "5px" }}>
                                        <label className="tarrif-weight-box-heading">{e.serviceid.toUpperCase()}  ({e.toWeight.toFixed(2)} Kg - {e.weight.toFixed(2)} Kg)</label>
                                        <div className="row stretch-content">
                                            <span className="col-lg-4 col-sm-12 tariff-weight-box">WC</span>
                                            <span className="col-lg-4 col-sm-12 tariff-weight-box">SZ</span>
                                            <span className="col-lg-4 col-sm-12 tariff-weight-box">DZ</span>
                                        </div>
                                        <div className="row stretch-content">

                                            <div className="col-lg-4 col-sm-12 tariff-weight-box"> {e.fromWerightToWeight.filter(t => t.toZoneCode === "LOCAL")[0].price} </div>
                                            <div className="col-lg-4 col-sm-12 tariff-weight-box">{e.fromWerightToWeight.filter(t => t.toZoneCode === "SAME")[0].price} </div>
                                            <div className="col-lg-4 col-sm-12 tariff-weight-box"> {e.fromWerightToWeight.filter(t => t.toZoneCode === "DIFF")[0].price} </div>
                                        </div>
                                    </div>)) :
                                        <label className="tarrif-weight-box-heading">Tarrif not available.</label>
                                }
                            </div>


                            <div className="row mt-3">
                                <div className="col-lg-2 col-sm-12">
                                    <label>Fuel Factor</label>
                                    <input type="text" className="form-control" value={`${data?.fafType ? "FAC" : "FAF"}`} disabled />
                                </div>
                                <div className="col-lg-2 col-sm-12">
                                    <label></label>
                                    <input type="text" className="form-control" value={`${data?.fuelFactorValue}%`} disabled />
                                </div>
                                <div className="col-lg-4 col-sm-12">
                                    <label>Invoicing Scheduler</label>
                                    <input type="text" className="form-control" value={data?.invoiceschedule === 1 ? "Monthly" : data?.invoiceschedule === 2 ? "Daily" : "Weekly"} disabled />
                                </div>

                                <div className="col-lg-4 col-sm-12">
                                    <label>Recovery Type</label>
                                    <input type="text" className="form-control" value={!data?.recoveryType ? "Auto" : "Manual"} disabled />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-4 col-sm-12">
                                    <label>Credit Terms/Days</label>
                                    <input type="text" className="form-control" value={data?.creditTermsDays === null ? 0 : data?.creditTermsDays} disabled />
                                </div>
                                <div className="col-lg-4 col-sm-12">
                                    <label>Sales Decision</label>
                                    <input type="text" className="form-control" value={data?.salesdecisions} disabled />
                                </div>
                                <div className="col-lg-4 col-sm-12">
                                    <label>Billing Instruction</label>
                                    <input type="text" className="form-control" value={data?.billingInstruction} disabled />
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-lg-4 col-sm-12">
                                    <label>Annual Rate Revision</label>
                                    <input type="text" className="form-control" value={data?.annualRateRevision === null ? 0 : data?.annualRateRevision} disabled />
                                </div>
                                <div className="col-lg-4 col-sm-12">
                                    <label>E-Invoicing</label>
                                    <input type="text" className="form-control" value={data?.eInvoicing} disabled />
                                </div>
                                <div className="col-lg-4 col-sm-12">
                                    <label>Print Invoice</label>
                                    <input type="text" className="form-control" value={data?.printinvoice === 0 ? "NO" : "YES"} disabled />
                                </div>
                            </div>


                            <div className="row mt-3">
                                <div className="col-lg-4 col-sm-12">
                                    <label>Minimum Billing</label>
                                    <input type="text" className="form-control" value={data?.minBillingAmount} disabled />
                                </div>
                                <div className="col-lg-4 col-sm-12">
                                    <label>Recovery Mode</label>
                                    <input type="text" className="form-control" value={data?.recoveryMode === null ? "Cash" : data?.recoveryMode} disabled />
                                </div>
                                <div className="col-lg-4 col-sm-12">
                                    <label>Tax Excemption</label>
                                    <input type="text" className="form-control" value={data?.taxExceptions} disabled />
                                </div>
                            </div>
                        </div>
                    </fieldset> */}



                    <fieldset className="customer-info-fieldset">
                        <legend className="customer-info-legend" data-bs-toggle="collapse" data-bs-target="#POCDetails" aria-expanded="false" aria-controls="POCDetails">M&P POC Details </legend>
                        <div className="row mt-3 collapse show" id="POCDetails">
                            <div className="col-lg-4 col-sm-12">
                                <label>Sales Person</label>
                                <input type="text" className="form-control" value={data?.salesPerson} disabled />
                            </div>
                            <div className="col-lg-4 col-sm-12">
                                <label>Contact Number</label>
                                <input type="text" className="form-control" value={data?.pocPhoneNo} disabled />
                            </div>
                            <div className="col-lg-4 col-sm-12">
                                <label>Email ID</label>
                                <input type="text" className="form-control" value={data.pocEmail} disabled />
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="customer-info-fieldset" id="EmailNotificationsID">
                        <legend className="customer-info-legend" data-bs-toggle="collapse" data-bs-target="#EmailNotifications" aria-expanded="false" aria-controls="EmailNotifications">Email Notifications</legend>
                        <div className="row collapse show" id="EmailNotifications">
                            <div className="col-lg col-sm-12" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                <button type='button' className='btn  btn-sm btn-primary' onClick={onAdd}>Add Email</button>
                            </div>
                            <div className="row">
                                <div className="table-responsive">

                                    <table className="table table-sm table-bordered mt-3">
                                        <thead>
                                            <tr>
                                                <th>TO</th>
                                                <th>CC</th>
                                                <th>Type</th>
                                                <th>Remove</th>
                                                <th>Edit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                emailNotifications.map((x, index) => (
                                                    <tr key={index}>
                                                        <td className="vertical-align">{x.ToEmail.split(",").filter(e => e !== "").join(", ")}</td>
                                                        <td className="vertical-align">{x.CcEmail.split(",").filter(e => e !== "").join(", ")}</td>
                                                        <td className="vertical-align"><div style={{ width: "120px" }}>{emailNotificationType.filter(e => (x.ReportType.includes(String(e.id)))).map(e => e.reportName).join(", ")}</div></td>
                                                        <td className="vertical-align">
                                                            <button type="button" style={{ width: 60 }} className="btn btn-sm btn-primary" onClick={() => removeEmail(x)}>Remove</button>
                                                        </td>
                                                        <td className="vertical-align">
                                                            <div><button type='button' style={{ width: 60 }} className='btn btn-sm btn-primary' onClick={() => onEdit(x)}>Edit</button></div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </fieldset >
                </div>
            </>
            : viewType === "edit" ?
                <>
                    <EmailNotificationsUpdate
                        setViewType={setViewType}
                        emailData={emailData}
                        updateEmailData={updateEmailData}
                        emailNotificationType={emailNotificationType}
                        emailNotificationPayload={emailNotificationPayload}
                        setEmailNotificationPayload={setEmailNotificationPayload}
                        data={data}
                        userInfo={userInfo.id}
                        dispatch={dispatch}
                        setData={setData}
                        subAccWithLoc={subAccWithLoc}
                        setSubAccWithLoc={setSubAccWithLoc}
                    />
                </>
                : <>
                    <EmailNotificationsAdd
                        setViewType={setViewType}
                        emailData={emailData}
                        updateEmailData={updateEmailData}
                        emailNotificationType={emailNotificationType}
                        emailNotificationPayload={emailNotificationPayload}
                        setEmailNotificationPayload={setEmailNotificationPayload}
                        data={data}
                        userInfo={userInfo.id}
                        dispatch={dispatch}
                        subtractionNumber={emailNotifications.length}
                        emailNotifications={emailNotifications}
                        setData={setData}
                    />
                </>
        }
    </section >
}

export default CustomerInfo;